"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontSizes = void 0;

var styled_components_1 = require("styled-components");

exports.FontSizes = {
  display: {
    v100: {
      fontSize: 36,
      lineHeight: 36
    },
    v200: {
      fontSize: 40,
      lineHeight: 40
    },
    v300: {
      fontSize: 54,
      lineHeight: 54
    },
    v400: {
      fontSize: 74,
      lineHeight: 74
    }
  },
  heading: {
    v100: {
      fontSize: 20,
      lineHeight: 20
    },
    v200: {
      fontSize: 22,
      lineHeight: 24
    },
    v300: {
      fontSize: 24,
      lineHeight: 28
    },
    v400: {
      fontSize: 28,
      lineHeight: 32
    }
  },
  subhead: {
    v100: {
      fontSize: 10,
      lineHeight: 12
    },
    v200: {
      fontSize: 12,
      lineHeight: 16
    },
    v300: {
      fontSize: 14,
      lineHeight: 16
    },
    v400: {
      fontSize: 16,
      lineHeight: 20
    },
    v500: {
      fontSize: 18,
      lineHeight: 20
    }
  },
  body: {
    v100: {
      fontSize: 14,
      lineHeight: 20
    },
    v200: {
      fontSize: 16,
      lineHeight: 24
    },
    v300: {
      fontSize: 18,
      lineHeight: 28
    }
  },
  label: {
    v100: {
      fontSize: 12,
      lineHeight: 16
    },
    v200: {
      fontSize: 14,
      lineHeight: 16
    },
    v300: {
      fontSize: 16,
      lineHeight: 18
    },
    v400: {
      fontSize: 18,
      lineHeight: 20
    }
  },
  detail: {
    v100: {
      fontSize: 12,
      lineHeight: 16
    },
    v200: {
      fontSize: 14,
      lineHeight: 16
    },
    v300: {
      fontSize: 16,
      lineHeight: 18
    }
  }
};

var getFontSize = function (group, value) {
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: ", "px;\n"], ["\n  font-size: ", "px;\n  line-height: ", "px;\n"])), exports.FontSizes[group][value].fontSize, exports.FontSizes[group][value].lineHeight);
};

exports.default = {
  name: 'Carvana',
  color: {
    primary: {
      v100: '#CFEAF2',
      v200: '#00AED9',
      v300: '#018DC0',
      v400: '#00619E',
      v500: '#045489',
      v600: '#183558',
      v700: '#122946'
    },
    secondary: {
      v100: '#fbf2de',
      v200: '#feb948',
      v300: '#eb9f23'
    },
    neutral: {
      v000: '#000000',
      v100: '#ffffff',
      v200: '#F4F8FA',
      v300: '#D9DDE9',
      v400: '#AAB1C7',
      v500: '#757989'
    },
    validation: {
      warning: '#feb948',
      success: '#1dd08b',
      error: '#ff7171'
    }
  },
  grid: {
    columns: 12,
    gap: 16
  },
  breakpoint: {
    xs: 0,
    sm: 414,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1440
  },
  depth: {
    elevation: {
      v100: 'none',
      v200: '0px 2px 3px rgba(24, 53, 88, 0.1)',
      v300: '0px 6px 13px rgba(24, 53, 88, 0.1)'
    }
  },
  border: {
    radius: '3px'
  },
  font: {
    family: "'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    weight: {
      v100: '300',
      v200: '400',
      v300: '700'
    },
    display: {
      v100: getFontSize('display', 'v100'),
      v200: getFontSize('display', 'v200'),
      v300: getFontSize('display', 'v300'),
      v400: getFontSize('display', 'v400')
    },
    heading: {
      v100: getFontSize('heading', 'v100'),
      v200: getFontSize('heading', 'v200'),
      v300: getFontSize('heading', 'v300'),
      v400: getFontSize('heading', 'v400')
    },
    subhead: {
      v100: getFontSize('subhead', 'v100'),
      v200: getFontSize('subhead', 'v200'),
      v300: getFontSize('subhead', 'v300'),
      v400: getFontSize('subhead', 'v400'),
      v500: getFontSize('subhead', 'v500')
    },
    body: {
      v100: getFontSize('body', 'v100'),
      v200: getFontSize('body', 'v200'),
      v300: getFontSize('body', 'v300')
    },
    label: {
      v100: getFontSize('label', 'v100'),
      v200: getFontSize('label', 'v200'),
      v300: getFontSize('label', 'v300'),
      v400: getFontSize('label', 'v400')
    },
    detail: {
      v100: getFontSize('detail', 'v100'),
      v200: getFontSize('detail', 'v200'),
      v300: getFontSize('detail', 'v300')
    }
  },
  form: {
    focus: {
      light: styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        box-shadow: 0 0 0 1px white, 0 0 0 3px #018dc0;\n      "], ["\n        box-shadow: 0 0 0 1px white, 0 0 0 3px #018dc0;\n      "]))),
      dark: styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        box-shadow: 0 0 0 1px #018dc0, 0 0 0 3px white;\n      "], ["\n        box-shadow: 0 0 0 1px #018dc0, 0 0 0 3px white;\n      "])))
    }
  }
};
var templateObject_1, templateObject_2, templateObject_3;